export function arrayContainsValueFromOtherArray (arrayToSearch, otherArray) {
  return otherArray.some((value) => {
    return arrayToSearch.includes(value)
  })
}



// WEBPACK FOOTER //
// ./src/utils/array/arrayContainsValueFromOtherArray.js